import { render, staticRenderFns } from "./OnlineDaysTableTab.vue?vue&type=template&id=752dc970&scoped=true&"
import script from "./OnlineDaysTableTab.vue?vue&type=script&lang=ts&"
export * from "./OnlineDaysTableTab.vue?vue&type=script&lang=ts&"
import style0 from "./OnlineDaysTableTab.vue?vue&type=style&index=0&id=752dc970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752dc970",
  null
  
)

export default component.exports